/* global axios */
import ApiClient from './ApiClient';

class CampaignsAPI extends ApiClient {
  constructor() {
    super('campaigns', { accountScoped: true });
  }

  // WhatsApp V1 state-machine actions - see Campaigns::CampaignStateService
  // and Api::V1::Accounts::CampaignsController on the backend.
  schedule(id, scheduledAt) {
    return axios.post(`${this.url}/${id}/schedule`, {
      scheduled_at: scheduledAt,
    });
  }

  sendNow(id) {
    return axios.post(`${this.url}/${id}/send_now`);
  }

  pause(id) {
    return axios.post(`${this.url}/${id}/pause`);
  }

  resume(id) {
    return axios.post(`${this.url}/${id}/resume`);
  }

  cancel(id) {
    return axios.post(`${this.url}/${id}/cancel`);
  }

  retryFailed(id) {
    return axios.post(`${this.url}/${id}/retry_failed`);
  }

  recipients(id, { status, page = 1 } = {}) {
    const params = new URLSearchParams();
    if (status) params.set('status', status);
    if (page) params.set('page', page);
    const query = params.toString();
    return axios.get(`${this.url}/${id}/recipients${query ? `?${query}` : ''}`);
  }

  analytics(id) {
    return axios.get(`${this.url}/${id}/analytics`);
  }

  // Read-only audience count preview for the creation wizard - reuses the
  // exact same Campaigns::AudienceResolutionService the backend uses at
  // materialize time, never resolved client-side.
  estimateAudience(audienceConfig) {
    return axios.post(`${this.url}/estimate_audience`, {
      audience_config: audienceConfig,
    });
  }
}

export default new CampaignsAPI();
